import { IDS_TO_COMMUNITIES } from './constants';

const NAMES_GENERATOR = ['Habitat for...', 'Clean Air..', 'Society for...'];

export const NAMES = [];

// need 111 to test paginiation :)
for (let i = 0; i < 111; i++) {
    NAMES.push(NAMES_GENERATOR[Math.floor(Math.random() * 3)]);
}

export const RESULTS_LIST = NAMES.map((name, i) => {
    const randomCommunityType = Math.floor(Math.random() * 9);
    return {
        name,
        id: i,
        // type: testResult.type,
        // type: communities
        type: IDS_TO_COMMUNITIES[randomCommunityType],
        text: {
            location: `San Fran number: ${i}`,
            img: '#',
            caption: 'photo caption',
            content: 'longer description of org..  .. . . . . . ....... ..........',
        },
    };
});

/*export const SOCIAL_MEDIA = [
    {
        id: 1,
        content: 'Social media content',
    },
    {
        id: 2,
        content: 'Social media content',
    },
    {
        id: 3,
        content: 'Social media content',
    },
    {
        id: 4,
        content: 'Social media content',
    },
    {
        id: 5,
        content: 'Social media content',
    },
    {
        id: 6,
        content: 'Social media content',
    },
    {
        id: 7,
        content: 'Social media content',
    },
    {
        id: 8,
        content: 'Social media content',
    },
    {
        id: 9,
        content: 'Social media content',
    },
    {
        id: 10,
        content: 'Social media content',
    },
];*/

export const CATEGORIES_FEATURED = [
    {
        id: 1,
        content: 'Featured in Cat',
    },
    {
        id: 2,
        content: 'Featured in Cat',
    },
    {
        id: 3,
        content: 'Featured in Cat',
    },
    {
        id: 4,
        content: 'Featured in Cat',
    },
    {
        id: 5,
        content: 'Featured in Cat',
    },
    {
        id: 6,
        content: 'Featured in Cat',
    },
    {
        id: 7,
        content: 'Featured in Cat',
    },
];

/*export const NEARBY_FEATURED = [
    {
        id: 1,
        content: 'Featured in Nearby',
    },
    {
        id: 2,
        content: 'Featured in Nearby',
    },
    {
        id: 3,
        content: 'Featured in Nearby',
    },
    {
        id: 4,
        content: 'Featured in Nearby',
    },
    {
        id: 5,
        content: 'Featured in Nearby',
    },
    {
        id: 6,
        content: 'Featured in Nearby',
    },
    {
        id: 7,
        content: 'Featured in Nearby',
    },
];*/

/*export const testFeature = {
    geometry: {
        type: 'Point',
        coordinates: [-95.9326171875, 41.25716209782706],
    },
    type: 'Feature',
    properties: {
        address: '1200 Douglas St',
        category_id: '3',
        city: 'Omaha',
        county: 'Douglas',
        donation_url: 'http://omahaperformingarts.org/support-the-arts/ways-to-give',
        facebook_url: 'https://www.facebook.com/OmahaPerformingArtsOrg',
        id: '3789026',
        instagram_url: '',
        is_featured: '0',
        mission:
            'Omaha Performing Arts is dedicated to enriching the lives of the citizens of Omaha and surrounding communities through the presentation of the highest quality local national and international artistic performances. OPA is committed to: the stewardship and management of the Orpheum Theater and the Holland Performing Arts Center; the presentation of a variety of the finest performing arts events; and education and community engagement programs to support and enhance an appreciation for the arts.',
        name: 'Omaha Performing Arts Society',
        phone: '1-402-345-0202',
        phone_extension: '',
        state: 'NE',
        twitter_url: 'https://twitter.com/OPerformingArts',
        url: 'http://www.omahaperformingarts.org',
        volunteer_url: 'http://omahaperformingarts.org/about-us/contact-us',
        zip: '68102',
    },
    id: 208,
    layer: {
        id: 'organizations-education',
        type: 'circle',
        source: 'composite',
        'source-layer': 'organizations-education',
        paint: {
            'circle-radius': 6,
            'circle-color': '#0095c8',
            'circle-stroke-color': '#ffffff',
            'circle-stroke-width': 1.5,
        },
    },
};*/
